import React, { useEffect, useState } from "react";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form, FieldArray, ErrorMessage } from "formik";
import { EmployeeSchema } from "../../../Schemas/employee/employee_schema";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import { FcBusinessman } from "react-icons/fc";
import { BsBoxArrowInRight } from "react-icons/bs";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { toTitleCase } from "../../../Components/Functions/word.fun";

const EditEmployee = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [reportingTo, setReportingTo] = useState([]);
  const [employeeInfo, setEmployeeInfo] = useState();
  const [leadOwner, setLeadOwner] = useState();
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/employeeManagement/getEmployeeManagementById/${id}`)
      .then((res) => setEmployeeInfo(res.data))
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [id]);
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setReportingTo(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  const handelSubmit = (values, actions) => {
    Object.keys(values).forEach((key) => {
      if (typeof values[key] === "string") {
        values[key] = values[key].trim();
      }
    });
    values = {
      ...values,
      firstName: toTitleCase(values.firstName),
      position: toTitleCase(values.position),
      lastName: toTitleCase(values.lastName),
      city: toTitleCase(values.city),
      permanantAddress: toTitleCase(values.permanantAddress),
      residentialAddress: toTitleCase(values.residentialAddress),
      emergencyContactName: toTitleCase(values.emergencyContactName),
      previousOrganizationName: toTitleCase(values.previousOrganizationName),
      previousOrganizationLocation: toTitleCase(
        values.previousOrganizationLocation
      ),
    };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest(
      "PATCH",
      `/employeeManagement/updateEmployeeManagement1st/${id}`,
      values,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", res.data.message);
          navigate(`/employee-management`);
        } else {
          Toast("error", "Error while uploading data");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error");
        // console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcBusinessman className="fs-2  me-1" /> Employee details
                </h2>
                <h4 className="text-muted">
                  <p>Edit employment details</p>
                  {/* <StepRoutes /> */}
                </h4>
              </div>
            </div>
          </div>
          <div className="card">
            {employeeInfo && (
              <Formik
                initialValues={employeeInfo}
                validationSchema={EmployeeSchema}
                // onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <>
                      <div className="card-body">
                        <div>
                          <h2 className="px-2">Employee Details</h2>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6 col-sm-12 px-4">
                            <div className="row mb-2">
                              <label className="form-label required">
                                First name
                              </label>
                              <div className="w-100">
                                <CustomInput name="firstName" type="text" />
                                {props.touched.firstName &&
                                  props.errors.firstName && (
                                    <p className="text-danger">
                                      {props.errors.firstName}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Last name
                              </label>
                              <div className="w-100">
                                <CustomInput name="lastName" type="text" />
                                {props.touched.lastName &&
                                  props.errors.lastName && (
                                    <p className="text-danger">
                                      {props.errors.lastName}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-12 my-1">
                              <div className="row">
                                <label className="form-label required">
                                  Gender
                                </label>
                                <div className="w-100">
                                  <CustomSelect type="text" name="gender">
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="prefer not to mention">
                                      Prefer not to mention
                                    </option>
                                  </CustomSelect>
                                  {props.touched.gender &&
                                    props.errors.gender && (
                                      <p className="text-danger">
                                        {props.errors.gender}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Contact number
                              </label>
                              <div className="w-100">
                                <CustomInput name="contactNumber" type="text" />
                                {props.touched.contactNumber &&
                                  props.errors.contactNumber && (
                                    <p className="text-danger">
                                      {props.errors.contactNumber}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="row mb-2">
                              <label className="form-label ">
                                Employee Personal Email Id
                              </label>
                              <div className="w-100">
                                <CustomInput type="text" name="personalEmail" />
                                {props.touched.personalEmail &&
                                  props.errors.personalEmail && (
                                    <p className="text-danger">
                                      {props.errors.personalEmail}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="row mb-2">
                              <label className="form-label required">
                                Aadhar card number
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  name="aadharcardNumber"
                                  type="text"
                                />
                                {props.touched.aadharcardNumber &&
                                  props.errors.aadharcardNumber && (
                                    <p className="text-danger">
                                      {props.errors.aadharcardNumber}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Pan card number
                              </label>
                              <div className="w-100">
                                <CustomInput name="pancardNumber" type="text" />
                                {props.touched.pancardNumber &&
                                  props.errors.pancardNumber && (
                                    <p className="text-danger">
                                      {props.errors.pancardNumber}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Position
                              </label>
                              <div className="w-100">
                                <CustomInput name="position" type="text" />
                                {props.touched.position &&
                                  props.errors.position && (
                                    <p className="text-danger">
                                      {props.errors.position}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Interview Date
                              </label>
                              <div className="w-100">
                                <CustomInput type="date" name="interviewDate" />
                                {props.touched.interviewDate &&
                                  props.errors.interviewDate && (
                                    <p className="text-danger">
                                      {props.errors.interviewDate}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12 px-4">
                            <div className="row mb-2">
                              <label className="form-label required">
                                Role in organization
                              </label>

                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="roleInOrganisation"
                                >
                                  <option value="">Select Role</option>

                                  <option value="adminStaff">
                                    Admin Staff
                                  </option>
                                  <option value="agronomistStaff">
                                    Agronomist Staff
                                  </option>
                                  <option value="accountStaff">
                                    Account Staff
                                  </option>
                                  <option value="clientFeedback">
                                    Client Feedback
                                  </option>
                                  <option value="HR">Human Resources</option>
                                  <option value="inspectionStaff">
                                    Inspection Staff
                                  </option>
                                  <option value="ITStaff">IT Staff</option>
                                  <option value="Jr.HR">
                                    Jr. Human Resources
                                  </option>
                                  <option value="labourStaff">
                                    Labour Staff
                                  </option>
                                  <option value="marketingStaff">
                                    Marketing Staff
                                  </option>
                                  <option value="officeStaff">
                                    Office Staff
                                  </option>
                                  <option value="opsStaff">Ops Staff</option>
                                  <option value="purchaseStaff">
                                    Purchase Staff
                                  </option>
                                  <option value="SMMStaff">SMM Staff</option>
                                  <option value="saleStaff">Sales Staff</option>
                                  <option value="salesAdmin">
                                    Sales Admin
                                  </option>
                                  <option value="salesManager">
                                    Sales Manager
                                  </option>
                                  <option value="salesCoordinator">
                                    Sales Coordinator
                                  </option>
                                  <option value="superAdmin">
                                    Super Admin
                                  </option>
                                  <option value="marketingAgency">
                                    Marketing Agency
                                  </option>
                                </CustomSelect>
                                {props.touched.roleInOrganisation &&
                                  props.errors.roleInOrganisation && (
                                    <p className="text-danger">
                                      {props.errors.roleInOrganisation}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Date of joining
                              </label>
                              <div className="w-100">
                                <CustomInput type="date" name="dateOfJoining" />
                                {props.touched.dateOfJoining &&
                                  props.errors.dateOfJoining && (
                                    <p className="text-danger">
                                      {props.errors.dateOfJoining}
                                    </p>
                                  )}
                              </div>
                            </div>
                            {/* <div className="row mb-2">
                              <label className="form-label required">
                                Package joined at
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  type="text"
                                  name="packageJoinedAt"
                                />
                                {props.touched.packageJoinedAt &&
                                  props.errors.packageJoinedAt && (
                                    <p className="text-danger">
                                      {props.errors.packageJoinedAt}
                                    </p>
                                  )}
                              </div>
                            </div> */}
                            <div className="row mb-2">
                              <label className="form-label required">
                                Permanant address
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  name="permanantAddress"
                                  type="text"
                                />
                                {props.touched.permanantAddress &&
                                  props.errors.permanantAddress && (
                                    <p className="text-danger">
                                      {props.errors.permanantAddress}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Residential address
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  name="residentialAddress"
                                  type="text"
                                />
                                {props.touched.residentialAddress &&
                                  props.errors.residentialAddress && (
                                    <p className="text-danger">
                                      {props.errors.residentialAddress}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                City
                              </label>
                              <div className="w-100">
                                <CustomInput type="text" name="city" />
                                {props.touched.city && props.errors.city && (
                                  <p className="text-danger">
                                    {props.errors.city}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div className="row mb-2">
                              <label className="form-label ">
                                Free Lancer Staff
                              </label>

                              <div className="w-100">
                                <CustomSelect type="text" name="isfreeLancer">
                                  <option value="">Select</option>
                                  <option value="freeLancerStaff">
                                    Free Lancer Staff
                                  </option>
                                </CustomSelect>
                                {props.touched.isfreeLancer &&
                                  props.errors.isfreeLancer && (
                                    <p className="text-danger">
                                      {props.errors.isfreeLancer}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div>
                          <h2 className="px-2">Info for Appointment</h2>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6 col-sm-12 px-4">
                            <div className="row mb-2">
                              <label className="form-label required">
                                Email address
                              </label>
                              <div className="w-100">
                                <CustomInput name="emailId" type="email" />
                                {props.touched.emailId &&
                                  props.errors.emailId && (
                                    <p className="text-danger">
                                      {props.errors.emailId}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Date of birth
                              </label>
                              <div className="w-100">
                                <CustomInput name="dateOfBirth" type="date" />
                                {props.touched.dateOfBirth &&
                                  props.errors.dateOfBirth && (
                                    <p className="text-danger">
                                      {props.errors.dateOfBirth}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Bank account number
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  name="bankAccountNumber"
                                  type="text"
                                />
                                {props.touched.bankAccountNumber &&
                                  props.errors.bankAccountNumber && (
                                    <p className="text-danger">
                                      {props.errors.bankAccountNumber}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="row mb-2">
                              <label className="w-25 form-label required">
                                Qualification
                              </label>
                              <div className="w-100">
                                <CustomSelect type="text" name="qualification">
                                  <option value="">Select</option>
                                  <option value="high_school">
                                    High School
                                  </option>
                                  <option value="associate_degree">
                                    Associate Degree
                                  </option>
                                  <option value="bachelor_degree">
                                    Bachelor's Degree
                                  </option>
                                  <option value="master_degree">
                                    Master's Degree
                                  </option>
                                  <option value="phd">PhD</option>
                                  <option value="vocational_certificate">
                                    Vocational Certificate
                                  </option>
                                  <option value="diploma">Diploma</option>
                                  <option value="professional_certification">
                                    Professional Certification
                                  </option>
                                  <option value="postgraduate_certificate">
                                    Postgraduate Certificate
                                  </option>
                                  <option value="technical_degree">
                                    Technical Degree
                                  </option>
                                  <option value="trade_school">
                                    Trade School
                                  </option>
                                  <option value="online_course">
                                    Online Course
                                  </option>
                                  <option value="apprenticeship">
                                    Apprenticeship
                                  </option>
                                  <option value="military_training">
                                    Military Training
                                  </option>
                                  <option value="bootcamp">Bootcamp</option>
                                </CustomSelect>
                                {props.touched.qualification &&
                                  props.errors.qualification && (
                                    <p className="text-danger">
                                      {props.errors.qualification}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Emergency contact name
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  name="emergencyContactName"
                                  type="text"
                                />
                                {props.touched.emergencyContactName &&
                                  props.errors.emergencyContactName && (
                                    <p className="text-danger">
                                      {props.errors.emergencyContactName}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Emergency contact number
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  name="emergencyContactNumber"
                                  type="text"
                                />
                                {props.touched.emergencyContactNumber &&
                                  props.errors.emergencyContactNumber && (
                                    <p className="text-danger">
                                      {props.errors.emergencyContactNumber}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Emergency contact relation
                              </label>
                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="emergencyContactRelation"
                                >
                                  <option value="">Select</option>
                                  <option value="father">Father</option>
                                  <option value="mother">Mother</option>
                                  <option value="spouse">Spouse</option>
                                  <option value="sister">Sister</option>
                                  <option value="brother">Brother</option>
                                  <option value="friend">Friend</option>
                                </CustomSelect>
                                {props.touched.emergencyContactRelation &&
                                  props.errors.emergencyContactRelation && (
                                    <p className="text-danger">
                                      {props.errors.emergencyContactRelation}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Laptop given by organisation
                              </label>
                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="laptopGivenByOrganisation"
                                >
                                  <option value="">Select</option>
                                  <option value="no">No</option>
                                  <option value="yes">Yes</option>
                                </CustomSelect>
                                {props.touched.laptopGivenByOrganisation &&
                                  props.errors.laptopGivenByOrganisation && (
                                    <p className="text-danger">
                                      {props.errors.laptopGivenByOrganisation}
                                    </p>
                                  )}
                              </div>
                            </div>
                            {props.values.laptopGivenByOrganisation ===
                            "yes" ? (
                              <div className="row mb-2">
                                <label className="form-label required">
                                  Laptop id:
                                </label>

                                <div className="w-100">
                                  <CustomInput
                                    type="text"
                                    required
                                    name="laptopId"
                                  />

                                  {props.touched.laptopId &&
                                    props.errors.laptopId && (
                                      <p className="text-danger">
                                        {props.errors.laptopId}
                                      </p>
                                    )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="row mb-2">
                              <label className="form-label required">
                                Mobile given by organisation
                              </label>

                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="mobileGivenByOrganisation"
                                >
                                  <option value="">Select</option>
                                  <option value="no">No</option>
                                  <option value="yes">Yes</option>
                                </CustomSelect>
                                {props.touched.mobileGivenByOrganisation &&
                                  props.errors.mobileGivenByOrganisation && (
                                    <p className="text-danger">
                                      {props.errors.mobileGivenByOrganisation}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Working place
                              </label>
                              <div className="w-100">
                                <div className="w-100 col">
                                  <div>
                                    {["office", "farm", "home"].map((place) => (
                                      <label
                                        key={place}
                                        className="form-check form-check-inline"
                                      >
                                        <CustomRadioButton
                                          name="workingPlace"
                                          value={place}
                                          checked={
                                            props.values.workingPlace == place
                                          }
                                          onChange={() =>
                                            props.setFieldValue(
                                              "workingPlace",
                                              place
                                            )
                                          }
                                        />
                                        <span className="form-check-label">
                                          {place === "home"
                                            ? "Work From Home"
                                            : place.charAt(0).toUpperCase() +
                                              place.slice(1)}
                                        </span>
                                      </label>
                                    ))}
                                  </div>
                                  <ErrorMessage
                                    name="workingPlace"
                                    component="p"
                                    className="text-danger"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12 px-4">
                            <div className="row mb-2">
                              <label className="form-label required">
                                PF/PT deduction
                              </label>
                              <div className="w-100">
                                <CustomInput type="text" name="pfptDeduction" />
                                {props.touched.pfptDeduction &&
                                  props.errors.pfptDeduction && (
                                    <p className="text-danger">
                                      {props.errors.pfptDeduction}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Mode of salary
                              </label>

                              <div className="w-100">
                                <CustomSelect type="text" name="modeOfSalary">
                                  <option value="">Select</option>
                                  <option value="cash">Cash</option>
                                  <option value="nft">NFT</option>
                                  <option value="cheque">Cheque</option>
                                </CustomSelect>
                                {props.touched.modeOfSalary &&
                                  props.errors.modeOfSalary && (
                                    <p className="text-danger">
                                      {props.errors.modeOfSalary}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Hired via agency or direct
                              </label>

                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="hireViaAgencyOrDirect"
                                >
                                  <option value="">Select</option>
                                  <option value="agency">Agency</option>
                                  <option value="direct">Direct</option>
                                </CustomSelect>
                                {props.touched.hireViaAgencyOrDirect &&
                                  props.errors.hireViaAgencyOrDirect && (
                                    <p className="text-danger">
                                      {props.errors.hireViaAgencyOrDirect}
                                    </p>
                                  )}
                              </div>
                            </div>
                            {props.values.hireViaAgencyOrDirect === "agency" ? (
                              <div className="row mb-2">
                                <label className="form-label required">
                                  Agency expense (exl GST)
                                </label>
                                <div className="w-100">
                                  <CustomInput
                                    required
                                    name="agencyExpences_exlGST"
                                    type="text"
                                  />
                                  {props.touched.agencyExpences_exlGST &&
                                    props.errors.agencyExpences_exlGST && (
                                      <p className="text-danger">
                                        {props.errors.agencyExpences_exlGST}
                                      </p>
                                    )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            <div className="row mb-2">
                              <label className="form-label required">
                                Total years of experience
                              </label>

                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="totalYearsOfExperience"
                                >
                                  <option value=""></option>
                                  <option value="0">0</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                  <option value="12">12</option>
                                  <option value="13">13</option>
                                  <option value="14">14</option>
                                  <option value="15">15</option>
                                  <option value="16">16</option>
                                  <option value="17">17</option>
                                  <option value="18">18</option>
                                  <option value="19">19</option>
                                  <option value="20">20</option>
                                  <option value="21">21</option>
                                  <option value="22">22</option>
                                  <option value="23">23</option>
                                  <option value="24">24</option>
                                  <option value="25">25</option>
                                </CustomSelect>
                                {props.touched.totalYearsOfExperience &&
                                  props.errors.totalYearsOfExperience && (
                                    <p className="text-danger">
                                      {props.errors.totalYearsOfExperience}
                                    </p>
                                  )}
                              </div>
                            </div>

                            {props.values.totalYearsOfExperience != 0 ? (
                              <div className="row mb-2">
                                <label className="form-label required">
                                  Previous organization name
                                </label>
                                <div className="w-100">
                                  <CustomInput
                                    required
                                    name="previousOrganizationName"
                                    type="text"
                                  />
                                  {props.touched.previousOrganizationName &&
                                    props.errors.previousOrganizationName && (
                                      <p className="text-danger">
                                        {props.errors.previousOrganizationName}
                                      </p>
                                    )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {props.values.totalYearsOfExperience != 0 ? (
                              <div className="row mb-2">
                                <label className="form-label required">
                                  Previous organization location
                                </label>
                                <div className="w-100">
                                  <CustomInput
                                    required
                                    name="previousOrganizationLocation"
                                    type="text"
                                  />
                                  {props.touched.previousOrganizationLocation &&
                                    props.errors
                                      .previousOrganizationLocation && (
                                      <p className="text-danger">
                                        {
                                          props.errors
                                            .previousOrganizationLocation
                                        }
                                      </p>
                                    )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {/* <div className="row mb-2">
                              <label className="form-label required">
                                Salary per month
                              </label>
                              <div className="w-100">
                                <CustomInput
                                  type="text"
                                  name="salaryPerMonth"
                                />
                                {props.touched.salaryPerMonth &&
                                  props.errors.salaryPerMonth && (
                                    <p className="text-danger">
                                      {props.errors.salaryPerMonth}
                                    </p>
                                  )}
                              </div>
                            </div> */}

                            <div className="row mb-2">
                              <label className="form-label required">
                                Reporting to
                              </label>

                              <div className="w-100">
                                <CustomSelect type="text" name="reportingTo">
                                  <option value="">Select</option>
                                  {reportingTo &&
                                    reportingTo.map((emp) => {
                                      return (
                                        <option key={emp?.id} value={emp?.id}>
                                          {emp?.userName}
                                        </option>
                                      );
                                    })}
                                </CustomSelect>
                                {props.touched.reportingTo &&
                                  props.errors.reportingTo && (
                                    <p className="text-danger">
                                      {props.errors.reportingTo}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Assign Buddy
                              </label>
                              <div className="w-100">
                                <CustomSelect name="assignBuddy" type="text">
                                  <option value="">Select</option>

                                  {leadOwner &&
                                    leadOwner?.map((state, index) => (
                                      <option key={state?.id} value={state?.id}>
                                        {state?.userName}
                                      </option>
                                    ))}
                                </CustomSelect>
                                {props.touched.assignBuddy &&
                                  props.errors.assignBuddy && (
                                    <p className="text-danger">
                                      {props.errors.assignBuddy}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <label className="form-label required">
                                Contract of employment
                              </label>
                              <div className="w-100">
                                <CustomSelect
                                  name="contractOfEmployment"
                                  type="text"
                                >
                                  <option value="">Select Contract</option>
                                  <option value="0">0</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                </CustomSelect>
                                {props.touched.contractOfEmployment &&
                                  props.errors.contractOfEmployment && (
                                    <p className="text-danger">
                                      {props.errors.contractOfEmployment}
                                    </p>
                                  )}
                              </div>
                            </div>

                            {props.values.mobileGivenByOrganisation ===
                            "yes" ? (
                              <div className="row mb-2">
                                <label className="form-label required">
                                  Mobile id:
                                </label>

                                <div className="w-100">
                                  <CustomInput
                                    type="text"
                                    required
                                    name="mobileId"
                                  />

                                  {props.touched.mobileId &&
                                    props.errors.mobileId && (
                                      <p className="text-danger">
                                        {props.errors.mobileId}
                                      </p>
                                    )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="row mb-2">
                              <label className="form-label required">
                                SIM card given by organisation
                              </label>

                              <div className="w-100">
                                <CustomSelect
                                  type="text"
                                  name="simCardGivenByOrganisation"
                                >
                                  <option value="">Select</option>
                                  <option value="no">No</option>
                                  <option value="yes">Yes</option>
                                </CustomSelect>
                                {props.touched.simCardGivenByOrganisation &&
                                  props.errors.simCardGivenByOrganisation && (
                                    <p className="text-danger">
                                      {props.errors.simCardGivenByOrganisation}
                                    </p>
                                  )}
                              </div>
                            </div>
                            {props.values.simCardGivenByOrganisation ===
                            "yes" ? (
                              <div className="row mb-2">
                                <label className="form-label required">
                                  Sim Card Number:
                                </label>

                                <div className="w-100">
                                  <CustomInput
                                    type="text"
                                    required
                                    name="simCardNumber"
                                  />

                                  {props.touched.simCardNumber &&
                                    props.errors.simCardNumber && (
                                      <p className="text-danger">
                                        {props.errors.simCardNumber}
                                      </p>
                                    )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="row row-deck g-3">
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">Photograph:</h3>
                              </div>
                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.photograph}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer ">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "photograph",
                                      e.target.files[0]
                                    )
                                  }
                                  name="photograph"
                                  type="file"
                                />
                                {props.touched.photograph &&
                                  props.errors.photograph && (
                                    <p className="text-danger">
                                      {props.errors.photograph}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Aadhar card front:{" "}
                                </h3>
                              </div>
                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.aadharcardPhotoFront}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "aadharcardPhotoFront",
                                      e.target.files[0]
                                    )
                                  }
                                  name="aadharcardPhotoFront"
                                  type="file"
                                />
                                {props.touched.aadharcardPhotoFront &&
                                  props.errors.aadharcardPhotoFront && (
                                    <p className="text-danger">
                                      {props.errors.aadharcardPhotoFront}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Aadhar card back:
                                </h3>
                              </div>

                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.aadharcardPhotoBack}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "aadharcardPhotoBack",
                                      e.target.files[0]
                                    )
                                  }
                                  name="aadharcardPhotoBack"
                                  type="file"
                                />
                                {props.touched.aadharcardPhotoBack &&
                                  props.errors.aadharcardPhotoBack && (
                                    <p className="text-danger">
                                      {props.errors.aadharcardPhotoBack}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">Pan card:</h3>
                              </div>

                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.pancardPhoto}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "pancardPhoto",
                                      e.target.files[0]
                                    )
                                  }
                                  name="pancardPhoto"
                                  type="file"
                                />
                                {props.touched.pancardPhoto &&
                                  props.errors.pancardPhoto && (
                                    <p className="text-danger">
                                      {props.errors.pancardPhoto}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Offer letter acceptance:
                                </h3>
                              </div>

                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.offerLetterAcceptance}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "offerLetterAcceptance",
                                      e.target.files[0]
                                    )
                                  }
                                  name="offerLetterAcceptance"
                                  type="file"
                                />
                                {props.touched.offerLetterAcceptance &&
                                  props.errors.offerLetterAcceptance && (
                                    <p className="text-danger">
                                      {props.errors.offerLetterAcceptance}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Joining letter scan:
                                </h3>
                              </div>

                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.joiningLetterScan}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "joiningLetterScan",
                                      e.target.files[0]
                                    )
                                  }
                                  name="joiningLetterScan"
                                  type="file"
                                />
                                {props.touched.joiningLetterScan &&
                                  props.errors.joiningLetterScan && (
                                    <p className="text-danger">
                                      {props.errors.joiningLetterScan}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">Bank passbook:</h3>
                              </div>

                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.bankpassbookPhoto}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "bankpassbookPhoto",
                                      e.target.files[0]
                                    )
                                  }
                                  name="bankpassbookPhoto"
                                  type="file"
                                />
                                {props.touched.bankpassbookPhoto &&
                                  props.errors.bankpassbookPhoto && (
                                    <p className="text-danger">
                                      {props.errors.bankpassbookPhoto}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">
                                  Residential proof:
                                </h3>
                              </div>

                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.residentialProofPhoto}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "residentialProofPhoto",
                                      e.target.files[0]
                                    )
                                  }
                                  name="residentialProofPhoto"
                                  type="file"
                                />
                                {props.touched.residentialProofPhoto &&
                                  props.errors.residentialProofPhoto && (
                                    <p className="text-danger">
                                      {props.errors.residentialProofPhoto}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-3">
                            <div className="card">
                              <div className="card-header">
                                <h3 className="card-title">PF Card:</h3>
                              </div>
                              <div className="card-body">
                                <div>
                                  <LazyImageComponent
                                    width={"200px"}
                                    src={employeeInfo?.pfCardPhoto}
                                    alt={"kryzen Biotech"}
                                  />
                                </div>
                              </div>
                              <div className="card-footer">
                                <CustomInput
                                  onChange={(e) =>
                                    props.setFieldValue(
                                      "pfCardPhoto",
                                      e.target.files[0]
                                    )
                                  }
                                  name="pfCardPhoto"
                                  type="file"
                                />
                                {props.touched.pfCardPhoto &&
                                  props.errors.pfCardPhoto && (
                                    <p className="text-danger">
                                      {props.errors.pfCardPhoto}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        {employeeInfo?.progress && (
                          <h2 className="px-4">Onboarding Progress</h2>
                        )}
                        {employeeInfo?.progress && (
                          <FieldArray name="progress">
                            {({ push, remove }) =>
                              props.values.progress && (
                                <table className="table mt-3">
                                  <thead>
                                    <tr>
                                      <th scope="col">Sr</th>
                                      <th scope="col">Task</th>
                                      <th scope="col">Completed</th>
                                      <th scope="col">Completed Date</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {props.values.progress.map(
                                      (task, index) => (
                                        <tr key={task.task}>
                                          <td>{index + 1}</td>
                                          <td>{task.task}</td>
                                          <td>
                                            <input
                                              type="checkbox"
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                              checked={
                                                task.completed === true ||
                                                task.completed === "true"
                                              } // Convert to boolean
                                              onChange={() => {
                                                const isCompleted =
                                                  task.completed === true ||
                                                  task.completed === "true"; // Coerce string to boolean

                                                const endDate = !isCompleted
                                                  ? new Date()
                                                      .toISOString()
                                                      .split("T")[0]
                                                  : "";

                                                const updatedTask = {
                                                  ...task,
                                                  completed: !isCompleted, // Toggle the boolean value
                                                  endDate: endDate,
                                                };

                                                props.setFieldValue(
                                                  `progress[${index}]`,
                                                  updatedTask
                                                );
                                              }}
                                            />
                                          </td>
                                          <td>
                                            {task.completed === true ||
                                            task.completed === "true" ? (
                                              <span>
                                                {task.endDate || "N/A"}
                                              </span>
                                            ) : (
                                              "N/A"
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )
                            }
                          </FieldArray>
                        )}
                      </div>
                      <div>
                        {employeeInfo?.offBoardprogress &&
                          employeeInfo?.employeeStatus == "offBoarding" && (
                            <h2 className="px-4">Offboarding Progress</h2>
                          )}
                        {employeeInfo?.offBoardprogress &&
                          employeeInfo?.employeeStatus == "offBoarding" && (
                            <FieldArray name="offBoardprogress">
                              {({ push, remove }) =>
                                props.values.offBoardprogress && (
                                  <table className="table mt-3">
                                    <thead>
                                      <tr>
                                        <th scope="col">Sr</th>
                                        <th scope="col">Task</th>
                                        <th scope="col">Completed</th>
                                        <th scope="col">Completed Date</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {props.values.offBoardprogress.map(
                                        (task, index) => (
                                          <tr key={task.task}>
                                            <td>{index + 1}</td>
                                            <td>{task.task}</td>
                                            <td>
                                              <input
                                                type="checkbox"
                                                style={{
                                                  height: "20px",
                                                  width: "20px",
                                                }}
                                                checked={
                                                  task.completed === true ||
                                                  task.completed === "true"
                                                } // Convert to boolean
                                                onChange={() => {
                                                  const isCompleted =
                                                    task.completed === true ||
                                                    task.completed === "true"; // Coerce string to boolean

                                                  const endDate = !isCompleted
                                                    ? new Date()
                                                        .toISOString()
                                                        .split("T")[0]
                                                    : "";

                                                  const updatedTask = {
                                                    ...task,
                                                    completed: !isCompleted, // Toggle the boolean value
                                                    endDate: endDate,
                                                  };

                                                  props.setFieldValue(
                                                    `offBoardprogress[${index}]`,
                                                    updatedTask
                                                  );
                                                }}
                                              />
                                            </td>
                                            <td>
                                              {task.completed === true ||
                                              task.completed === "true" ? (
                                                <span>
                                                  {task.endDate || "N/A"}
                                                </span>
                                              ) : (
                                                "N/A"
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                )
                              }
                            </FieldArray>
                          )}
                      </div>
                    </>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        {/* <FormSubmitButton buttonText="Save Employee Details" /> */}
                        <button
                          className=" btn mx-1 mt-2  btn-primary"
                          onClick={() => handelSubmit(props.values)}
                        >
                          <BsBoxArrowInRight className="fs-2 me-2" />
                          SAVE EMPLOYEE DETAILS
                        </button>
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditEmployee;
